import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import * as Const from 'util/constants';
import './CategoryList.scss';
import { asyncFilterBundlesByCateg } from 'actions/bundles';
import { asyncFilterTemplatesByCateg } from 'actions/templates';

export class CategoryList extends Component {
  static propTypes = {
    categories: PropTypes.array,
    fetchBundlesByCateg: PropTypes.func,
    fetchTemplatesByCateg: PropTypes.func
  };

  selectCategory = categId => {
    const { fetchBundlesByCateg, fetchTemplatesByCateg, type } = this.props;
    if (type === Const.TYPE_TEMPLATES) {
      // template
      fetchTemplatesByCateg(categId);
    } else {
      // image & audio bundle
      fetchBundlesByCateg(categId);
    }
  };

  render() {
    const { categories, currentCategId } = this.props;
    return (
      <div className="category-list">
        <h3 className="list-header">Categories</h3>
        <div className="list-content">
          <div
            key="0"
            className={classNames('item', { active: !currentCategId })}
            onClick={() => this.selectCategory()}
          >
            All
          </div>
          {categories.map(category => (
            <div
              key={category.id}
              className={classNames('item', { active: category.id === currentCategId })}
              onClick={() => this.selectCategory(category.id)}
            >
              {category.name}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { bundles, templates, categories, user } = state;
  const bundleType = user.bundleType;
  return {
    categories,
    currentCategId: bundleType === Const.TYPE_IMAGE_BUNDLES ? bundles.categId : templates.categId,
    type: bundleType
  };
};

const mapDispatchToProps = dispatch => ({
  fetchBundlesByCateg: categId => dispatch(asyncFilterBundlesByCateg(categId)),
  fetchTemplatesByCateg: categId => dispatch(asyncFilterTemplatesByCateg(categId))
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoryList);
